import { CardsgroupComponent } from './../cardsgroup/cardsgroup.component';
import { ButtongroupComponent } from './../buttongroup/buttongroup.component';
import { RangeBarComponent } from './../range-bar/range-bar.component';
import { ToggleSwitchComponent } from './../toggle-switch/toggle-switch.component';
import { PasswordComponent } from './../password/password.component';


import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { FileUploadModule } from 'ng2-file-upload';
import { NgSelectModule } from '@ng-select/ng-select';
import { MyDatePickerModule } from 'mydatepicker';
import { AgGridModule } from 'ag-grid-angular';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
 

// import { ChartComponent } from '../chart/chart.component';
// import { LoadDraftComponent } from '../load-draft/load-draft.component';
// import { GridPaginationComponent } from '../grid-pagination/grid-pagination.component';
// import { DraftFormComponent } from '../draft-form/draft-form.component';

import { TextBoxComponent } from '../text-box/text-box.component';
import { TextAreaComponent } from '../text-area/text-area.component';
import { DateComponent } from '../date/date.component';
import { CheckBoxComponent } from '../check-box/check-box.component';
import { ComboBoxComponent } from '../combo-box/combo-box.component';
import { FieldComponent } from '../field/field.component';
import { ButtonComponent } from '../button/button.component';
import { HiddenComponent } from '../hidden/hidden.component';
import { AmountComponent } from '../amount/amount.component';
import { FormComponent } from '../form/form.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
// import { HttpLoaderFactory } from '../app.module';
import { LabelComponent } from '../label/label.component';
import { RadioButtonComponent } from '../radio-button/radio-button.component';
import { SkeletonLoaderComponent } from '../skeleton-loader/skeleton-loader.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { HttpLoaderFactory } from '../http-loader-factory';

@NgModule({
  imports: [
    CommonModule,
    FileUploadModule,
    MyDatePickerModule,
    FormsModule,
    NgSelectModule,
    HttpClientModule,
    NgxSkeletonLoaderModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,// Moved to Seperate File By Mirsha
        deps: [HttpClient]
      }
    }),
  ],
  declarations: [
    ComboBoxComponent,
    TextBoxComponent,
    TextAreaComponent,
    DateComponent,
    ButtonComponent,
    CheckBoxComponent,
    AmountComponent,
    FormComponent,
    HiddenComponent,
    // LoadDraftComponent,
    FieldComponent,
    LabelComponent,
    RadioButtonComponent,
    PasswordComponent,
    ToggleSwitchComponent,
    RangeBarComponent,
    ButtongroupComponent,
    SkeletonLoaderComponent,

    CardsgroupComponent
  ],
  exports: [
    ComboBoxComponent,
    TextBoxComponent,
    TextAreaComponent,
    DateComponent,
    ButtonComponent,
    CheckBoxComponent,
    AmountComponent,
    FormComponent,
    HiddenComponent,
    // LoadDraftComponent,
    FieldComponent,
    LabelComponent,
    RadioButtonComponent,
    PasswordComponent,
    ToggleSwitchComponent,
    RangeBarComponent,
    ButtongroupComponent,
    CardsgroupComponent,
    SkeletonLoaderComponent
  ]
})
export class RAFormModule { }
